/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Payment_Estimated_Installment_AmountInputs */

const en_case_payment_estimated_installment_amount = /** @type {(inputs: Case_Payment_Estimated_Installment_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimated installment amount`)
};

const pt_br2_case_payment_estimated_installment_amount = /** @type {(inputs: Case_Payment_Estimated_Installment_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor estimado da parcela`)
};

/**
* | output |
* | --- |
* | "Estimated installment amount" |
*
* @param {Case_Payment_Estimated_Installment_AmountInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_payment_estimated_installment_amount = /** @type {((inputs?: Case_Payment_Estimated_Installment_AmountInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Payment_Estimated_Installment_AmountInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_payment_estimated_installment_amount(inputs)
	return pt_br2_case_payment_estimated_installment_amount(inputs)
});